var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-inner-loading',{staticStyle:{"z-index":"9999 !important"},attrs:{"showing":_vm.isSubmitting}},[_c(_vm.loaderName,{tag:"component",attrs:{"size":"50px","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }